import { FC } from "react";
import { Box, createStyles, Link, makeStyles } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { Button, SocialButton } from "components";

const useStyles = makeStyles(() =>
  createStyles({
    loginLink: {
      textDecoration: "underline",
    },
  }),
);

interface SocialLoginProps {
  onGoToLogin: () => string;
  onRegularSignUp: () => void;
}

const SocialLogin: FC<SocialLoginProps> = ({
  onGoToLogin,
  onRegularSignUp,
}) => {
  const classes = useStyles();

  return (
    <Box width="60%" minWidth="260px" px={2}>
      <SocialButton provider="facebook" />
      <SocialButton provider="google" />
      <SocialButton provider="linkedin_oauth2" />
      <Button
        id="email-sig-up-button"
        variant="outlined"
        size="large"
        customColor="gray"
        onClick={onRegularSignUp}
        fullWidth
        disableRipple
        disableFocusRipple
        disableTouchRipple
        style={{ backgroundColor: "transparent", borderRadius: "2px" }}
      >
        Sign Up Using Email
      </Button>
      <Box textAlign="center" my={4} color="#2A313B">
        OR
      </Box>
      <Box textAlign="center">
        <Link
          component={RouterLink}
          to={onGoToLogin}
          className={classes.loginLink}
        >
          Log in to an existing account
        </Link>
      </Box>
    </Box>
  );
};

export default SocialLogin;
